var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass:
        "align-items-center document-request-collapse bg-white no-outline collapse-m",
      attrs: { "no-gutters": "" },
    },
    [
      _c(
        "b-col",
        { attrs: { md: "4", col: "" } },
        [
          _c(
            "b-row",
            { staticClass: "align-items-center collapse-m-header" },
            [
              _c(
                "b-col",
                { attrs: { cols: "10" } },
                [
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "align-items-center font-sm btn-link flex-nowrap",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c("h5", { staticClass: "mb-0 d-inline" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "btn btn-link font-sm collapsed no-outline pr-0",
                            attrs: { type: "button" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.classificationName) +
                                " \n            "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("icon", {
                        attrs: {
                          name: _vm.visible ? "caret-down" : "caret-right",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }